import { Fragment, type ReactNode } from "react";
import "./word-design.css";

/**
 * The Tarii wordmark as running text (#2337, founder 15 Oct 2026 evening).
 * `/site/tarii-wordmark.png` is `tarii-logo.png` cropped to the ink:
 * 356 by 181 px. The x-height is 109 of 181 px (0.602). The font's
 * x-height is 0.516 of its size, so the image height is 0.516 / 0.602 =
 * 0.857em and the wordmark x-height lands on the text x-height. The
 * image bottom is the letter baseline, so `vertical-align: baseline`
 * puts it on the text baseline. The alt text keeps screen readers and
 * accessible names reading "Tarii".
 */
export function TariiWord() {
  return (
    <img
      src="/site/tarii-wordmark.png"
      alt="Tarii"
      width={356}
      height={181}
      className="tarii-word"
      draggable={false}
    />
  );
}

/** Splits a plain string and swaps each "Tarii" for the wordmark. */
export function withTariiWord(text: string): ReactNode {
  const parts = text.split("Tarii");
  return parts.map((part, i) => (
    // biome-ignore lint/suspicious/noArrayIndexKey: static split of one string
    <Fragment key={i}>
      {i > 0 ? <TariiWord /> : null}
      {part}
    </Fragment>
  ));
}
